import React from 'react'
import Label from './Label'

function Input({ label, isTextArea, ...rest }) {
    return (
        <div className='w-full flex flex-col gap-1'>
            <Label>{label}</Label>
            {isTextArea
                ? <textarea className='border outline-none border-[#EFEFEF] rounded-[10px] p-3 w-full placeholder:text-[#C7C7C7]' rows={4} {...rest} />
                : <input type='text' className='border outline-none border-[#EFEFEF] rounded-[10px] p-3 w-full placeholder:text-[#C7C7C7]' {...rest} />
            }
        </div>
    )
}

export default Input